import React from "react";

import Slider from "react-slick";
import useStrings from "../hooks/useStrings";

const Testimonials = ({ classicHeader, darkTheme }) => {
  const langStrings = useStrings();

  const reviews = [
    {
      name: "Grzegorz Głowacki",
      position: "Technical Support Manager at Appfire",
      initials: "GG",
      color: "#0d6efd",
      desc: "I worked closely with Wojtek who served as an excellent developer of our corporate CMS/CRM and web mapping systems. Wojtek is the most knowledgeable and accomplished professional that I have worked with in this field. Don't pass on the opportunity to work with Wojtek, he is one of the smartest and hardest working IT professionals I know.",
      rating: null,
    },
    {
      name: "Gosia Rakowska",
      position: "Front-end Developer",
      initials: "GR",
      color: "#198754",
      desc: "I am delighted to recommend Wojciech without reservation. Over the past two years, I've witnessed his exceptional work ethic, collaborative spirit, and ability to deliver high-quality results consistently. Wojciech is a quick learner, proactive, and a true team player. His contributions have made a significant impact, and I am confident he will be a valuable asset wherever he goes.",
      rating: null,
    },
    {
      name: "Piotr Osowiecki",
      position: "Solutions Architect",
      initials: "PO",
      color: "#fd7e14",
      desc: "Wojciech is a hard working, seeking the best solutions professional with a lot of knowledge about code development good practices and programming skills in PHP, Java. Beside that he is really good colleague and work with him is a pure pleasure.",
      rating: null,
    },
    {
      name: "Michał Izydorski",
      position: "Tech Lead",
      initials: "MI",
      color: "#6f42c1",
      desc: "Reliable and experienced manager and technical guy, what is not always coherent.",
      rating: null,
    },
  ];

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
    ],
  };
  return (
    <section
      id="testimonial"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            {langStrings.testimonialsTitle1}
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            {langStrings.testimonialsTitle2}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}

        <Slider {...settings}>
          {reviews.length > 0 &&
            reviews.map((value, index) => (
              <div className="item" key={index}>
                <div
                  className={
                    " rounded p-5 " + (darkTheme ? "bg-dark" : "bg-light")
                  }
                >
                  <div className="d-flex align-items-center mt-auto mb-4">
                    <div
                      className="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "56px",
                        height: "56px",
                        backgroundColor: value.color,
                        color: "#fff",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      {value.initials}
                    </div>
                    <p className="ms-3 mb-0">
                      <strong
                        className={
                          "d-block fw-600 " +
                          (darkTheme ? "text-white" : "text-dark")
                        }
                      >
                        {value.name}
                      </strong>
                      <span className="text-muted fw-500">
                        {" "}
                        {value.position}{" "}
                      </span>
                    </p>
                  </div>
                  <p
                    className={
                      " fw-500 mb-4 " + (darkTheme ? "text-white" : "text-dark")
                    }
                  >
                    “{value.desc}”
                  </p>
                  {value.rating !== null && <span className="text-2">
                    {[...Array(value.rating)].map((value, i) => (
                        <i className="fas fa-star text-warning" key={i}/>
                    ))}
                  </span>}
                  <p className="text-2 text-muted mb-0 mt-2">
                    <i className="fab fa-linkedin text-primary me-1" />
                    via LinkedIn
                  </p>
                </div>
              </div>
            ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;
